(($) => {

    const HIDE = 'd-none';

    $.fn.contentSelector = function (tree) {
        const el = $(this);
        const selects = el.find('select');
        const select0 = selects.eq(0);
        const select1 = selects.eq(1);
        const cta = el.find('a');
        setOptions(select0, tree.map(x => x.name), 1);
        select0.on('change', event => {
            const val = select0.val();
            cta.addClass(HIDE);
            if (val !== "") {
                select1.removeAttr('disabled');
                const index = parseInt(val);
                setOptions(select1, tree[index].options.map(x => x.name), 2);
            }
            else {
                select1.attr('disabled', true);
                setOptions(select1, [], 2);
            }
        });
        select1.on('change', event => {
            const val0 = select0.val();
            const val1 = select1.val();

            cta.removeAttr("target");
            cta.attr('data-action', '');
            cta.attr('data-label', '');

            if (val1 !== "") {
                const i0 = parseInt(val0);
                const i1 = parseInt(val1);
                const link = tree[i0].options[i1].link;

                var dataAction = tree[i0].name;
                var dataLabel = tree[i0].options[i1].name;
                var linkTarget = link.target;

                cta.attr('href', link.url);

                //Start of RAD-555,601
                if (linkTarget) {
                    cta.attr('target', linkTarget);
                }
                cta.attr('data-action', dataAction);
                cta.attr('data-label', dataLabel);
                //End of RAD-555,601

                cta.text(link.text);
                cta.removeClass(HIDE);
            }
            else {
                cta.addClass(HIDE);
            }
        });
    };

    function setOptions(select, names, place) {
        var placeholder = "";

        if (place === 1) placeholder = "Select First"
        else placeholder = "Select Second";

        const html = `<option value="">` + placeholder + `</option>`
            + names.map((n, i) => `<option value=${i}>${n}</option>`).join('');
        select.html(html);
    }

})(jQuery);
